import React, { useContext, useEffect } from "react";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckIcon from "@mui/icons-material/Check";
import UserService from "../../services/UserService";

import LanguageContext from "../../LanguageContext";
import messages from "../../services/messages";
import _ from "lodash";
import firebase from "../../firebase";

import { Call } from "@mui/icons-material";
import Divider from "@mui/material/Divider";

const EnrollNow = ({
  classes,
  paymentPackage,
  location,
  joinLink,
  section,
  userType,
  clickHandler,
  userSource,
}) => {
  const language = useContext(LanguageContext);
  const [state, setState] = React.useState(null);

  useEffect(() => {
    const userInfo = UserService.getUserInfo();
    setState(userInfo.state);
  }, []);

  const signupEventName =
    location === "landing" ? "signup_clicked" : "subscription_payment_clicked";

  return <>
    {paymentPackage && !_.isEmpty(paymentPackage) && (
      <div className={classes.whiteSection}>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item className={classes.item} style={{ width: "50vw" }}>
            <Typography
              variant={"h6"}
              style={{ fontWeight: "bold", marginBottom: "8px" }}
            >
              {messages["landing.startNow"][language]}
            </Typography>
          </Grid>
        </Grid>

        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item>
            <Typography
              variant={"subtitle1"}
              style={{ opacity: "70%", textDecoration: "line-through" }}
            >
              ₹ {paymentPackage.amount}/-
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Grid item xs={1} md={4} lg={5} xl={5}></Grid>
          <Grid item xs={5} md={3} lg={2} xl={1}>
            <Typography variant={"h4"} style={{ fontWeight: "bold" }}>
              ₹ {paymentPackage.amount_after_discount}/-
            </Typography>
          </Grid>
          <Grid item xs={3} md={2} lg={1} xl={1}>
            <Typography variant={"subtitle1"} style={{ fontWeight: "bold" }}>
              {paymentPackage.duration / 30}
              {messages["landing.offerMonths"][language]}
            </Typography>
          </Grid>

          <Grid xs={3} md={3} lg={4} xl={5} item>
            <div
              style={{
                background: `url(../../icons/offer.svg)`,
                width: "60px",
                height: "60px",
                textAlign: "center",
                backgroundRepeat: "no - repeat",
                backgroundPosition: "center",
                backgroundSize: "80px 80px",
              }}
            >
              <Typography
                style={{
                  padding: "10px 10px 0px 12px",
                  fontWeight: "bold",
                  marginTop: "9%",
                }}
              >
                {paymentPackage.discount_percentage}%
              </Typography>
              <Typography
                style={{
                  fontWeight: "bold",
                  padding: "0px 12px 0px 8px",
                  marginTop: "-5px",
                }}
              >
                off
              </Typography>
            </div>
          </Grid>
        </Grid>

        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item>
            <List>
              <ListItem style={{ verticalAlign: "top" }}>
                <ListItemIcon style={{ minWidth: "10vw" }}>
                  <CheckIcon />
                </ListItemIcon>
                <ListItemText
                  primary={`
                  ${messages["landing.offerPoints2Start"][language]} 
                  ${paymentPackage.duration / 30} 
                  ${messages["landing.offerPoints2Months"][language]}`}
                />
              </ListItem>
              <ListItem style={{ verticalAlign: "top" }}>
                <ListItemIcon style={{ minWidth: "10vw" }}>
                  <CheckIcon />
                </ListItemIcon>
                <ListItemText
                  primary={messages["landing.offerPoints3"][language]}
                />
              </ListItem>
              <ListItem style={{ verticalAlign: "top" }}>
                <ListItemIcon style={{ minWidth: "10vw" }}>
                  <CheckIcon />
                </ListItemIcon>
                <ListItemText
                  primary={messages["landing.offerPoints4"][language]}
                />
              </ListItem>
              <ListItem style={{ verticalAlign: "top" }}>
                <ListItemIcon style={{ minWidth: "10vw" }}>
                  <CheckIcon />
                </ListItemIcon>
                <ListItemText
                  primary={messages["landing.offerPoints5"][language]}
                />
              </ListItem>
              <ListItem style={{ verticalAlign: "top" }}>
                <ListItemIcon style={{ minWidth: "10vw" }}>
                  <CheckIcon />
                </ListItemIcon>
                <ListItemText
                  primary={messages["landing.offerPoints6"][language]}
                />
              </ListItem>
            </List>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          style={{ margin: "1vh 0vh" }}
        >
          <Grid item>
            <Typography
              variant={"subtitle1"}
              style={{ fontWeight: "bold", marginLeft: "8px" }}
            >
              {messages["landing.limitedOffer"][language]}
            </Typography>
          </Grid>
        </Grid>

        {paymentPackage.freebies_amount &&
          paymentPackage.freebies_amount > 0 && (
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item>
                <img src={"../../icons/offerProduct.svg"} alt="" />
              </Grid>
              <Grid
                item
                style={{
                  marginLeft: "2px",
                  width: "230px",
                  textAlign: "left",
                }}
              >
                <Typography
                  variant={"subtitle1"}
                  style={{ lineHeight: "inherit" }}
                >
                  {messages["landing.freebiesTextStart"][language]} ₹{" "}
                  {paymentPackage.freebies_amount}/-{" "}
                  {messages["landing.freebiesTextEnd"][language]}
                </Typography>
              </Grid>
            </Grid>
          )}

        {location && location === "landing" && (
          <>
            <br />
            <Divider />
            <br />
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item>
                <Typography
                  variant={"body1"}
                  align={"center"}
                  color={"primary"}
                >
                  {messages["landing.pricingSubtitle1"][language]}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item>
                <Typography
                  variant={"body1"}
                  align={"center"}
                  color={"primary"}
                >
                  {messages["landing.pricingSubtitle2"][language]}
                </Typography>
              </Grid>
            </Grid>

            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item>
                <Button
                  href={"/join"}
                  size={"large"}
                  color={"primary"}
                  variant={"contained"}
                  endIcon={<ArrowForwardIcon />}
                  style={{ margin: "8px 8px 8px 8px" }}
                  onClick={() => {
                    let stateName = state
                      ? state.name_en.toLowerCase()
                      : "maharashtra";
                    firebase.analytics().logEvent("joingold_clicked", {
                      state_name: stateName,
                      page: location,
                      section: section,
                      user_type: userType,
                      user_source: userSource,
                    });
                  }}
                >
                  {messages["landing.tryFree"][language]}
                </Button>
              </Grid>
            </Grid>
            <br />
          </>
        )}
        {location && location !== "landing" && (
          <>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item>
                <Button
                  size={"large"}
                  color={"primary"}
                  variant={"contained"}
                  startIcon={<Call />}
                  style={{ margin: "24px 8px 24px 8px" }}
                  onClick={clickHandler}
                >
                  {messages["landing.callMe"][language]}
                </Button>
              </Grid>
            </Grid>
          </>
        )}
      </div>
    )}
  </>;
};

export default EnrollNow;
